module.exports = "pegasus_template/assets/theme5/twitter-icon-1.png";